var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"palta-desktop",attrs:{"id":"app"}},[_c('palta-workspace',{staticClass:"main"},[_c('palta-view',{attrs:{"scroll":"vertical"}},[_c('router-view')],1)],1),_c('palta-notifications')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }